import { useTRPC } from "../../../../trpc/client";
import { useQueryClient } from "@tanstack/react-query";

export function useDownloadInvoice() {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const downloadPdf = async (merchantid: string, invoiceId: string) => {
    const data = await queryClient.fetchQuery(
      trpc.invoices.getPdf.queryOptions({
        rentalsMerchantId: merchantid,
        id: invoiceId,
      })
    );

    if (data?.url) {
      const response = await fetch(data.url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${invoiceId}.pdf`);
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  };

  return {
    downloadPdf,
  };
}
